module.exports = __webpack_public_path__ + "fonts/Muli-SemiBold.e59f36a1.woff";